export default __webpack_public_path__ + "static/media/rinu nair.bb3092d2.jpg";